import { useStaticQuery, graphql } from "gatsby";

const PopupQuery = (iban: string | undefined) => {
  const data = useStaticQuery(graphql`
    query PopupDataQuery {
      allSanityPopup {
        nodes {
          title
          description
          link {
            ...sanityLink
          }
          region {
            iban
          }
          image {
            _key
            _type
            altText
            asset {
              url
              gatsbyImageData(
                layout: FULL_WIDTH
                formats: [AUTO, WEBP]
                width: 800
              )
            }
          }
        }
      }
    }
  `);

  if (iban) {
    const findRegionPopup = data.allSanityPopup.nodes.find(popup => {
      return popup.region?.iban === iban;
    });
    return findRegionPopup;
  }

  return data.allSanityPopup.nodes[0];
};

export default PopupQuery;
